import { printf, toText } from "../../../fable_modules/fable-library-js.4.19.0/String.js";
import { keyValueList } from "../../../fable_modules/fable-library-js.4.19.0/MapUtil.js";
import { ofArray, empty, singleton, append } from "../../../fable_modules/fable-library-js.4.19.0/List.js";
import { Types_RequestProperties } from "../../../fable_modules/Fable.Fetch.2.7.0/Fetch.fs.js";
import { Auto_generateBoxedDecoderCached_Z6670B51 } from "../../../fable_modules/Thoth.Json.10.4.1/./Decode.fs.js";
import { File_AdminFileListItem_$reflection } from "../../../../Bfs.Web.Data.Service.Contracts/Kundenportal.Contracts.fs.js";
import { Paginated$1_$reflection } from "../../../../Bfs.Web.Data.Service.Contracts/Contracts.fs.js";
import { CaseStrategy } from "../../../fable_modules/Thoth.Json.10.4.1/Types.fs.js";
import { errorString, Encoders } from "../../../../Bfs.Web.Portale/./Http.fs.js";
import { fromString } from "../../../../Bfs.Web.Portale/../Bfs.Web.Kundenportal/fable_modules/Thoth.Json.10.4.1/Decode.fs.js";
import { int32ToString, numberHash, equals, uncurry2 } from "../../../fable_modules/fable-library-js.4.19.0/Util.js";
import { string_type, list_type, int32_type } from "../../../fable_modules/fable-library-js.4.19.0/Reflection.js";
import { errorCmd, request, Loaded, postEmpty } from "../../../../Bfs.Web.Portale/Http.fs.js";
import { map, defaultArg } from "../../../fable_modules/fable-library-js.4.19.0/Option.js";
import { Model, Msg, Model_Init } from "./Types.fs.js";
import { Cmd_none, Cmd_batch } from "../../../fable_modules/Fable.Elmish.4.2.0/cmd.fs.js";
import { tryInt } from "../../../../Bfs.Web.Portale/Helpers.fs.js";
import { contains } from "../../../fable_modules/fable-library-js.4.19.0/Seq.js";
import { Remote$1 } from "../../../../Bfs.Web.Portale/Types.fs.js";

export function Http_getFileList(page, kundennummer, kategorie) {
    let kategorie_2, kundennummer_2, arg_7, kundennummer_1, kategorie_1, arg_4;
    const response = fetch((kundennummer != null) ? ((kategorie != null) ? ((kategorie_2 = kategorie, (kundennummer_2 = (kundennummer | 0), (arg_7 = encodeURIComponent(kategorie_2), toText(printf("/api/admin/file?page=%i&kdnr=%i&kategorie=%s"))(page)(kundennummer_2)(arg_7))))) : ((kundennummer_1 = (kundennummer | 0), toText(printf("/api/admin/file?page=%i&kdnr=%i"))(page)(kundennummer_1)))) : ((kategorie != null) ? ((kategorie_1 = kategorie, (arg_4 = encodeURIComponent(kategorie_1), toText(printf("/api/admin/file?page=%i&kategorie=%s"))(page)(arg_4)))) : toText(printf("/api/admin/file?page=%i"))(page)), keyValueList(append(singleton(new Types_RequestProperties(4, ["include"])), empty()), 1));
    const decoder = Auto_generateBoxedDecoderCached_Z6670B51(Paginated$1_$reflection(File_AdminFileListItem_$reflection()), new CaseStrategy(1, []), Encoders());
    return response.then((response_1_1) => {
        if (!(response_1_1.ok)) {
            throw new Error(errorString(response_1_1));
        }
        else {
            const pr = response_1_1.text();
            return pr.then((res) => {
                const matchValue_1 = fromString(uncurry2(decoder), res);
                if (matchValue_1.tag === 1) {
                    throw new Error(matchValue_1.fields[0]);
                }
                else {
                    return matchValue_1.fields[0];
                }
            });
        }
    });
}

export function Http_getAllKundennummern() {
    const response = fetch("/api/admin/kundennummern", keyValueList(append(singleton(new Types_RequestProperties(4, ["include"])), empty()), 1));
    const decoder = Auto_generateBoxedDecoderCached_Z6670B51(list_type(int32_type), new CaseStrategy(1, []), Encoders());
    return response.then((response_1_1) => {
        if (!(response_1_1.ok)) {
            throw new Error(errorString(response_1_1));
        }
        else {
            const pr = response_1_1.text();
            return pr.then((res) => {
                const matchValue = fromString(uncurry2(decoder), res);
                if (matchValue.tag === 1) {
                    throw new Error(matchValue.fields[0]);
                }
                else {
                    return matchValue.fields[0];
                }
            });
        }
    });
}

export function Http_getAllKategorien() {
    const response = fetch("/api/admin/file/kategorien", keyValueList(append(singleton(new Types_RequestProperties(4, ["include"])), empty()), 1));
    const decoder = Auto_generateBoxedDecoderCached_Z6670B51(list_type(string_type), new CaseStrategy(1, []), Encoders());
    return response.then((response_1_1) => {
        if (!(response_1_1.ok)) {
            throw new Error(errorString(response_1_1));
        }
        else {
            const pr = response_1_1.text();
            return pr.then((res) => {
                const matchValue = fromString(uncurry2(decoder), res);
                if (matchValue.tag === 1) {
                    throw new Error(matchValue.fields[0]);
                }
                else {
                    return matchValue.fields[0];
                }
            });
        }
    });
}

export function Http_postActivate(id) {
    let arg;
    return postEmpty((arg = encodeURIComponent(id), toText(printf("/api/admin/file/%s/active"))(arg)));
}

export function Http_postDeactivate(id) {
    let arg;
    return postEmpty((arg = encodeURIComponent(id), toText(printf("/api/admin/file/%s/inactive"))(arg)));
}

export function Http_downloadUrl(f) {
    return toText(printf("/api/admin/file/%O"))(f.Id);
}

export function Http_downloadMetadataUrl(f) {
    return toText(printf("/api/admin/file/%O/metadata"))(f.Id);
}

export function State_init(page, user, lastModel) {
    const pagenumber = page.fields[0] | 0;
    const kdnr = page.fields[1];
    const kategorie = page.fields[2];
    const alleKundennummer = defaultArg(map((m) => m.AllKundennummern, lastModel), empty());
    const alleKategorien = defaultArg(map((m_1) => m_1.AllKategorien, lastModel), empty());
    return [Model_Init(pagenumber, kdnr, kategorie, alleKundennummer, alleKategorien), Cmd_batch(ofArray([singleton((dispatch) => {
        dispatch(new Msg(0, [pagenumber, kdnr, kategorie]));
    }), equals(alleKundennummer, empty()) ? singleton((dispatch_1) => {
        dispatch_1(new Msg(9, []));
    }) : Cmd_none(), equals(alleKategorien, empty()) ? singleton((dispatch_2) => {
        dispatch_2(new Msg(11, []));
    }) : Cmd_none()]))];
}

export function State_update(msg, model) {
    switch (msg.tag) {
        case 1:
            return [new Model(model.PageNumber, model.Kundennummer, model.Kategorie, Loaded(msg.fields[0]), model.AllKategorien, model.AllKundennummern, model.KundennummernFilterText, model.KundennummernFilterEnabeld), Cmd_none()];
        case 6:
            return [model, request(Http_postActivate, msg.fields[0], (Item_1) => (new Msg(8, [Item_1])))];
        case 7:
            return [model, request(Http_postDeactivate, msg.fields[0], (Item_2) => (new Msg(8, [Item_2])))];
        case 8:
            return [model, singleton((dispatch) => {
                dispatch(new Msg(0, [model.PageNumber, model.Kundennummer, model.Kategorie]));
            })];
        case 9:
            return [model, request(Http_getAllKundennummern, undefined, (Item_3) => (new Msg(10, [Item_3])))];
        case 10:
            if (msg.fields[0].tag === 1) {
                return [model, errorCmd((Item_4) => (new Msg(13, [Item_4])), "Laden aller Kundennummern", msg.fields[0].fields[0])];
            }
            else {
                return [new Model(model.PageNumber, model.Kundennummer, model.Kategorie, model.Files, model.AllKategorien, msg.fields[0].fields[0], model.KundennummernFilterText, model.KundennummernFilterEnabeld), Cmd_none()];
            }
        case 11:
            return [model, request(Http_getAllKategorien, undefined, (Item_5) => (new Msg(12, [Item_5])))];
        case 12:
            if (msg.fields[0].tag === 1) {
                return [model, errorCmd((Item_6) => (new Msg(13, [Item_6])), "Laden aller Kategorien", msg.fields[0].fields[0])];
            }
            else {
                return [new Model(model.PageNumber, model.Kundennummer, model.Kategorie, model.Files, msg.fields[0].fields[0], model.AllKundennummern, model.KundennummernFilterText, model.KundennummernFilterEnabeld), Cmd_none()];
            }
        case 5:
            return [model, singleton((dispatch_1) => {
                dispatch_1(new Msg(0, [1, model.Kundennummer, msg.fields[0]]));
            })];
        case 4: {
            const kdnr_2 = tryInt(model.KundennummernFilterText);
            return [model, ((kdnr_2 == null) ? false : contains(kdnr_2, model.AllKundennummern, {
                Equals: (x_1, y) => (x_1 === y),
                GetHashCode: numberHash,
            })) ? singleton((dispatch_2) => {
                dispatch_2(new Msg(0, [1, kdnr_2, model.Kategorie]));
            }) : Cmd_none()];
        }
        case 3:
            return [model, singleton((dispatch_3) => {
                dispatch_3(new Msg(0, [1, undefined, model.Kategorie]));
            })];
        case 2: {
            const kdnr_4 = tryInt(msg.fields[0]);
            return [new Model(model.PageNumber, model.Kundennummer, model.Kategorie, model.Files, model.AllKategorien, model.AllKundennummern, msg.fields[0], (kdnr_4 == null) ? false : contains(kdnr_4, model.AllKundennummern, {
                Equals: (x_2, y_1) => (x_2 === y_1),
                GetHashCode: numberHash,
            })), Cmd_none()];
        }
        case 13:
            return [model, Cmd_none()];
        default: {
            const cmd = request((tupledArg) => Http_getFileList(tupledArg[0], tupledArg[1], tupledArg[2]), [msg.fields[0], msg.fields[1], msg.fields[2]], (Item) => (new Msg(1, [Item])));
            return [new Model(model.PageNumber, msg.fields[1], msg.fields[2], new Remote$1(1, []), model.AllKategorien, model.AllKundennummern, defaultArg(map(int32ToString, msg.fields[1]), ""), true), cmd];
        }
    }
}

//# sourceMappingURL=State.fs.js.map
